import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Flame, Play, Star } from 'lucide-react';
import { gamesApi, Game } from '../services/api';
import { Link } from 'react-router-dom';

const PopulerOyunlar: React.FC = () => {
  const [oyunlar, setOyunlar] = useState<Game[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGames = async () => {
      try {
        const result = await gamesApi.list({ featured: true, pageSize: 8 });
        if (result.success && result.data?.games) {
          setOyunlar(result.data.games);
        }
      } catch (error) {
        console.error('Populer oyunlar yuklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    };

    loadGames();
  }, []);

  const displayData = oyunlar;

  return (
    <div className="bg-dark-800/50 backdrop-blur-sm rounded-2xl p-6 border border-dark-700 h-full flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-red-500 to-orange-500 flex items-center justify-center">
            <Flame className="w-5 h-5 text-white" />
          </div>
          <h2 className="text-xl font-bold text-white">En Popüler Oyunlar</h2>
        </div>
        <Link to="/slotlar/populer" className="text-primary-400 hover:text-primary-300 text-sm">
          Tümünü Gör →
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 flex-1">
        {loading ? (
          <>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div key={i} className="aspect-[3/4] bg-dark-700/50 rounded-xl animate-pulse" />
            ))}
          </>
        ) : (
          displayData.map((game, index) => (
            <motion.div
              key={game.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="group relative aspect-[3/4] rounded-xl overflow-hidden bg-dark-800 border border-dark-700 hover:border-primary-500/50 transition-all duration-300 cursor-pointer"
            >
              {/* Game Image */}
              <img
                src={game.thumbnailUrl || '/placeholder-game.png'}
                alt={game.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />

              {/* Play Button - Hover */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center shadow-lg shadow-primary-500/50 transform scale-75 group-hover:scale-100 transition-transform duration-300">
                  <Play className="w-6 h-6 text-white ml-1" />
                </div>
              </div>

              {/* Game Info */}
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-sm font-semibold text-white truncate mb-1">
                  {game.name}
                </h3>
                <p className="text-xs text-gray-400 truncate flex items-center">
                  <Star className="w-3 h-3 text-yellow-500 mr-1" />
                  {game.provider}
                </p>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
};

export default PopulerOyunlar;
